import {
  LayoutDashboard, SlidersHorizontal, Zap, LineChart, Settings2,
  UserCog, Bot, Info, Camera, Images, Mail,
} from "lucide-react";

export const TABS = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "controls", label: "Controls", icon: SlidersHorizontal },
  { id: "energy", label: "Energy", icon: Zap },
  { id: "grafana", label: "Grafana", icon: LineChart },
  { id: "settings", label: "Settings", icon: Settings2 },
  { id: "personalize", label: "Personalize", icon: UserCog },
  { id: "ai", label: "AI Chat", icon: Bot },
  { id: "about", label: "About", icon: Info },
  { id: "camera", label: "Camera", icon: Camera },
  { id: "gallery", label: "Gallery", icon: Images },
  { id: "contact", label: "Contact", icon: Mail },
];

export const DEFAULT_SETTINGS = {
  mqttHost: "broker.hivemq.cloud:8883",
  mqttUser: "campus_esp32",
  mqttPass: "",
  grafanaUrl: "https://cput-energy.grafana.net/d/campus",
  geminiKeys: "",
  deepseekKey: "",
  voiceEngine: "browser",
  elevenKey: "",
  azureKey: "",
  azureRegion: "eastus",
  voicerssKey: "",
  speechRate: 1,
  // personalize
  pirHold: 30,
  pirBrightness: 80,
  fan30: 36,
  fan60: 44,
  fan100: 52,
  fanCritical: 65,
  ledSchedule: false,
  ledOn: "18:00",
  ledOff: "06:00",
  ledDays: ["Mon", "Tue", "Wed", "Thu", "Fri"],
  camAutoFlash: true,
  camPirSnap: true,
  rapidInterval: 5,
  emailReports: false,
  emailTo: "henockhnk092@gmail.com",
  emailFreq: "daily",
  emailTime: "08:00",
  alertTemp: true,
  alertPower: true,
  alertMqtt: true,
};
